__turbopack_context__.v({
  "icon": "IconTheme-module-scss-module___QLgTW__icon",
});
